/*
 * @file: user.js
 * @description: Reducers and actions for store/manipulate user's  data
 * @date: 28.11.2019
 * @author: Anil
 */

/******** Reducers ********/

const initialState = {
    user_subscription: {
        loading: false,
        data: null,
        error: null
    },

};

export default function reducer(state = initialState, action) {
    switch (action.type) {

        case "getSubscription_pending":
            return {
                ...state,
                user_subscription: {
                    loading: true,
                    data: null,
                    error: null
                }
            };
        case "getSubscription_success":
            return {
                ...state,
                user_subscription: {
                    loading: false,
                    data: action.payload,
                    error: null
                }
            };
        case "getSubscription_failed":
            return {
                ...state,
                user_subscription: {
                    loading: false,
                    data: null,
                    error: action.payload
                }
            };

        default:
            return state;
    }
}



